export default __webpack_public_path__ + "static/media/logo-pag-inicial.097ad814.svg";